.mark { display: block; height: 12px; width: auto; }
